export default "__VITE_ASSET__VZLOSjNM__"